import moment from "moment-timezone";
import { getTimeZone } from "../stores/timeZone";

/** Parses ISO timestamps and the legacy Paris wall-clock format used by reports. */
export const parseDate = (value) => {
  if (value === null || value === undefined || value === "") return moment.invalid();
  if (typeof value !== "string") return moment.utc(value);
  if (/^\d{2}\/\d{2}\/\d{4} /.test(value)) {
    return moment.tz(
      value.replace(/\s+(AM|PM)(\s+CES?T)?$/i, ""),
      ["DD/MM/YYYY HH:mm:ss.SSS", "DD/MM/YYYY HH:mm:ss", "DD/MM/YYYY HH:mm"],
      true,
      "Europe/Paris"
    );
  }
  return moment.utc(value, moment.ISO_8601, true);
};

/** Sends an explicit UTC instant, preventing a second timezone conversion by the API. */
export const toUTCISOString = (value) => parseDate(value).toISOString();

/** Adapts an instant to Flatpickr's browser-local wall-clock representation. */
export const toPickerDate = (value, timeZone = getTimeZone()) => {
  if (!value) return null;
  const date = parseDate(value).tz(timeZone);
  return date.isValid() ? new Date(...date.toArray()) : null;
};

/** Converts a picker selection back to an instant, using the selected zone's DST rules. */
export const fromPickerDate = (value, timeZone = getTimeZone()) => {
  if (!value) return null;
  return moment.tz(moment(value).toArray(), timeZone).toDate();
};
